import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

@Injectable()
export class QrCodeHandler {
 	url: any;
 	token: any;
 	categoryId: any = 0;
  	businessId: any = 0; 

	constructor(
		public http: Http,
		public globals: Globals,
        public httpHelper: HttpHelper
	){
	}

	createQrCode(params, cb){
	    this.url = this.globals.dataUrl + 'qrcode/fromBody/url';

	    this.http
	    .post(
	      this.url, 
	      params, 
	      this.httpHelper.configOptionsWithToken(this.token)
	    )
	    .map(res => res.json())
	    .subscribe(response => {
	    	if(typeof cb == "function") cb(response.Data);
	    });         
	}
}
	


// WEBPACK FOOTER //
// ./src/providers/qrcode-handler.ts